import { render, staticRenderFns } from "./ImprovementTipForm.vue?vue&type=template&id=0bb996cb&scoped=true&"
import script from "./ImprovementTipForm.vue?vue&type=script&lang=js&"
export * from "./ImprovementTipForm.vue?vue&type=script&lang=js&"
import style0 from "./ImprovementTipForm.vue?vue&type=style&index=0&id=0bb996cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb996cb",
  null
  
)

export default component.exports